module.exports = __webpack_public_path__ + "static/media/logo-orixia-color.faf19b1c.png";